module.exports = __webpack_public_path__ + "static/media/skills-gap-analysis.9e0b612a.svg";